import { Form, useFormik, Field, ErrorMessage, FormikProvider } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { TfiReload } from "react-icons/tfi";
import { CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import { InfoAlert } from "../../CommonUtils/SweetAlerts";
import PublicHeader from "../../CommonUtils/PublicHeader";
import PublicFooter from "../../CommonUtils/PublicFooter";
import * as bie from "react-bootstrap";

export default function PaymentForm() {

    const user_id = sessionStorage.getItem('user_id');
    const instName = sessionStorage.getItem('instName');
    const logintype = sessionStorage.getItem('loginType');

    function generateCaptcha(length = 5) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const array = new Uint32Array(length);
        crypto.getRandomValues(array);
        return Array.from(array, num => chars[num % chars.length]).join('');
    }

    const [captcha, setCaptchaa] = useState('');

    useEffect(() => {
        setCaptchaa(generateCaptcha());
    }, []);

    const handleRefresh = () => {
        setCaptchaa(generateCaptcha());
    };


    useEffect(() => {
        const checkDevice = () => {
            //  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            //  const isMobileDevice = /android|iphone|ipad|ipod/i.test(userAgent);
        };

        checkDevice();
        window.addEventListener("resize", checkDevice);
        return () => window.removeEventListener("resize", checkDevice);
    }, []);

    useEffect(() => {
        const handlePageShow = (event) => {
            if (event.persisted) {
                // The page was loaded from the cache
                const hasReloaded = localStorage.getItem("hasReloaded");
                if (hasReloaded === 'true') {
                    localStorage.setItem("hasReloaded", "false");
                    window.location.reload();
                }
            }
        };
        window.addEventListener('pageshow', handlePageShow);
        return () => {
            window.removeEventListener('pageshow', handlePageShow);
        };
    }, []);

    // *****************Mobile count api *************************
    const handlePaymentInitiate = (url, values, additionalDispatches = []) => { //,navigatePath
        CommonAxiosPost(url, values).then((res) => {
            if (res.data !== null) {
                if (res.data.scode === "01") {

                    const form = document.createElement("form");
                    form.method = "POST";
                    form.action = "https://pgi.billdesk.com/pgidsk/PGIMerchantPayment";
                    form.style.display = "none";

                    const bdorderidInput = document.createElement("input");
                    bdorderidInput.type = "hidden";
                    bdorderidInput.name = "msg";
                    bdorderidInput.value = res?.data?.output;
                    form.appendChild(bdorderidInput);
                    document.body.appendChild(form);
                    form.submit();

                } else if (res.data.scode === "02" || res.data.scode === "03") {
                    Swal.fire({
                        text: res.data.sdesc,
                        icon: "warning",
                        backdrop: true,
                        allowOutsideClick: false,
                    }).then((cfm) => {
                        if (cfm.isConfirmed) {
                            // getCaptcha();
                            formIk.setFieldValue("captcha", "");
                        }
                    });
                }
            } else {
                InfoAlert("Oops! Something went wrong,Please check", "warning");
            }
        });
    };
    //**********submit logic ******************* */
    function submitFun(values) {
        if (captcha !== values.captcha) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid CAPTCHA',
                text: 'Please try again.',
                confirmButtonText: 'OK'
            }).then(() => {
                formIk.setFieldValue("captcha", '')
                handleRefresh()

            });
            return;
        }
        handlePaymentInitiate(config.url.API_URL + "paymentinitiate", values);//"/paymentBillDesk",

    }


    const formIk = useFormik
        ({
            enableReinitialize: true,
            initialValues: {
                //  fingerprint: "3763363390",
                //  useragent: navigator.userAgent,//"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/110.0.0.0 Safari/537.36",
                amount: "1.00",
                captcha: '',
                captchaId: '',
            },
            validationSchema: Yup.object().shape({

                captcha: Yup.string().required("Please enter Captcha").nullable(),
            }),

            onSubmit: (values) => {
                submitFun(values);
            }
        })

    return (
        <>
            <PublicHeader />
            {logintype == "college" ? (<>
                <FormikProvider value={formIk}>
                    <Form onChange={formIk.handleChange} onSubmit={formIk.handleSubmit}>

                        <bie.Container className="outer-page-content-container" style={{ fontFamily: 'bookman' }}>

                            <div className="inner-herbpage-service-title-sub">
                                <h4>Affiliation Application Payment 2025-26</h4>
                            </div>
                            <div style={{ marginTop: "5px" }} >
                                <bie.Row className="px-3 pt-3">
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3">

                                        <b>College Code:{user_id}</b>


                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={8} xl={8} xxl={8} className="mb-3">
                                        <b>College Name:{instName}</b>

                                    </bie.Col>
                                </bie.Row>
                                <bie.Row className="px-3 pt-3">
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} >
                                        <bie.InputGroup className="mb-3">
                                            <TfiReload onClick={() => { handleRefresh() }} size={20} className="mt-2" />&nbsp;
                                            {/* <img src={captcha} alt="Captcha" width='50%' height='50%' /> */}
                                            <h3> {captcha}</h3>&emsp;
                                            <Field placeholder="Enter Captcha" name="captcha" className="form-control" maxLength="5" />
                                            <ErrorMessage name="captcha" component="div" className="text-error" />
                                        </bie.InputGroup>
                                    </bie.Col>&emsp;
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>
                                        <button type="submit" className="btn btn-md rounded-0 btn-success" > Proceed to Pay Rs.2360/-</button>
                                        <b style={{ color: "red", fontSize: "20px" }}> (Affiliation Fee -2000 + 18% GST)</b>
                                    </bie.Col>
                                </bie.Row>

                                <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="mt-5" > <b style={{ fontWeight: "19px", fontSize: "24px" }}> *Note:  </b>
                                    <b style={{ fontWeight: "19px", fontSize: "20px", color: "red" }}>  If your payment has been deducted but you are still seeing the Payment page, your amount will be refunded to your account within 5 to 7 working days. In such case , Please pay the amount again.</b></bie.Col>
                            </div>
                        </bie.Container>
                    </Form>
                </FormikProvider >
            </>) : (<><div><b style={{ color: "red", fontSize: "22px", textAlign: "center" }}>This Service is only for college Login</b></div></>)}

            <div style={{ marginTop: '17%' }}>
                <PublicFooter />

            </div>
        </>
    )
}
